import css from './index.module.scss';
import { wintextObj } from './wintext';
import { useGlobal } from '@/utils/useGlobal';

export default function DownloadTheCertificates({ callback, desc }: any) {
    const { gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const wintext = wintextObj[locale as any] || wintextObj['us'];

    const clickHandle = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'click_get_a_quote',
                product_name: desc,
                position: 'Introduction',
                option_name: 'Floating_Get a Free Quote',
            });
        } catch (e) {
            console.error(e);
        } finally {
            callback && callback('open');
        }
    };
    return (
        <div
            className={`${css.DownloadTheCertificates} quote-win-float GtmModuleData-section`}
            data-section-id={'dpu-DownloadTheCertificates'}
            data-section-title={'dpu-DownloadTheCertificates'}
            onClick={clickHandle}
        >
            <div className="DownloadTheCertificates-l">
                <img src="https://websiteoss.ecoflow.com/upload/image/1747104618485/Frame%20161270361%20(1).png" />
            </div>
            <div className="DownloadTheCertificates-r">
                <div>
                    Download the Certificates
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path
                            d="M4.69238 1.76953L8.69238 5.76953L4.69238 9.76953"
                            stroke="white"
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>
        </div>
    );
}
